module.exports = __webpack_public_path__ + "static/media/Nuts – 1.c6c8fe45.jpg";